export default [
	{ id: 'llm', label: 'LLM', match: ['LLM', 'Deepseek', 'AI大世界'] },
	{ id: 'vrchat', label: 'VRChat', match: ['VRChat'] },
	{ id: 'ue5', label: 'UE5', match: ['UE5'] },
	{ id: 'cpp', label: 'C++', match: ['C++'] },
	{ id: 'gamejam', label: 'Game Jam', match: ['Game Jam'] },
	{ id: 'story', label: '世界观', match: ['世界观核心', '世界观'] },
	{ id: 'gaokao', label: '高考', match: ['高考'] },
	{ id: 'tool', label: '自用工具', match: ['自用工具'] },
	{ id: 'danmaku', label: '弹幕互动', match: ['弹幕互动'] },
	{ id: 'ai-anim', label: 'AI动画', match: ['AI动画'] },
	{ id: 'opensource', label: '开源', match: ['开源'] },
	{ id: 'multiplayer', label: '联机', match: ['联机', '网络联机'] },
	{ id: 'beyond-books', label: '不止于纸上', match: ['不止于纸上', '星铭世界'] },
	{ id: 'starfall', label: '星辉落', match: ['星辉落'] },
	{ id: 'visual-novel', label: '视觉小说', match: ['视觉小说'] }
]
